import React, { useState, useEffect } from 'react';
import FeatherIcon from 'feather-icons-react';
import { Modal, Row, Col, Form, Input, Select, Checkbox, message, Spin } from 'antd';
import PropTypes from 'prop-types';
import { AddUser } from '../style';
import { getStateData, getCityData, getCountryData } from '../../../Api/Services/CommonApiService'
import { FetchAccountDetails } from '../../../Api/Services/AccountApiService'
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { mobileOnChangeValidator, nameOnChangeValidator, validateZipCode, validateEmailField, validateAddressLine } from '../../../components/utilities/utilities';

const { Option } = Select;

const Popup = ({ confirmPopup, accountId, setConfirmPopup, popupType, popupContent, billingAddress, setBillingAddress, shipingAddress, setShipingAddress, }) => {
    const [form] = Form.useForm();
    const [country, setCountry] = useState()
    const [name, setName] = useState()
    const [email, setEmail] = useState()
    const [mobile, setMobile] = useState()
    const [state, setState] = useState()
    const [allState, setAllState] = useState()
    const [city, setCity] = useState()
    const [uiReady, setUiReady] = useState(false)
    const [allCity, setAllCity] = useState()
    const [zipcode, setZipcode] = useState()
    const [street, setStreet] = useState()
    const [allCountry, setAllCountry] = useState([])

    const getCountry = async () => {
        try {
            const response = await getCountryData()
            setAllCountry(response)
        }
        catch (error) {
            message.error(error)
        }
    }
    const handleClose = () => {
        setConfirmPopup(false)
    }
    const getCity = async (Address, isoCode) => {
        try {
            const response = await getCityData(isoCode)
            setAllCity(response);
            if (Address.city) {
                setCity(Address.city)
                form.setFieldsValue({
                    city: Address.city,
                })
                setUiReady(true)
            } else {
                setUiReady(true)
            }
        } catch (error) {
            setUiReady(true)
            message.error(error)
        }
    }
    const getState = async (Address, option) => {
        try {
            const response = await getStateData(option)
            setAllState(response);
            if (Address.state) {
                setState(Address.state)
                form.setFieldsValue({
                    state: Address.state,
                })
                const stateinfo = response.find(states => states.state === Address.state);
                if (stateinfo) {
                    const iso = stateinfo.stateId
                    getCity(Address, iso)
                } else {
                    setUiReady(true)
                }
            } else {
                setUiReady(true)
            }
        } catch (error) {
            setUiReady(true)
            message.error(error)
        }
    }
    const handleCountryChange = async (value, option) => {
        setCountry(value);
        if (option?.key) {
            try {
                const response = await getStateData(option.key)
                setAllState(response);
                setState()
                setAllCity([])
                setCity()
                form.setFieldsValue({
                    state: null,
                    city: null
                })
            } catch (error) {
                message.error(error)
            }
        } else {
            setAllState([]);
            setAllCity([])
            setState()
            setCity()
            form.setFieldsValue({
                state: null,
                city: null
            })
        }
    }
    const handleStateChange = async (value, option) => {
        setState(value);
        if (option?.key) {
            try {
                const response = await getCityData(option.key)
                setAllCity(response);
                setCity()
                form.setFieldsValue({
                    city: null
                })
            } catch (error) {
                message.error(error)
            }
        }
        else {
            setAllCity([]);
            setCity()
            form.setFieldsValue({
                city: null
            })
        }
    }
    const handleCityChange = (value) => {
        setCity(value)
    }
    async function onSubmit() {
        if (popupContent === "Billing") {
            setBillingAddress({ name, country, city, state, street, zipcode, email, mobile })
            setConfirmPopup(false)
        }
        if (popupContent === "Shipping") {
            setShipingAddress({ name, country, city, state, street, zipcode, email, mobile })
            setConfirmPopup(false)
        }
    }
    useEffect(() => {
        if (confirmPopup) {
            getCountry()
        }
    }, [confirmPopup])
    useEffect(() => {
        if (confirmPopup && allCountry) {
            if (popupType === "Create" && (popupContent === "Billing" || popupContent === "Shipping")) {
                setCountry(); setState(); setCity(); setZipcode(); setStreet(); setName();
                setEmail(popupContent === "Billing" ?
                    (billingAddress?.email ? billingAddress.email : undefined) : (
                        popupContent === "Shipping" &&
                        (shipingAddress?.email ? shipingAddress.email : undefined)))
                setMobile(popupContent === "Billing" ?
                    (billingAddress?.mobile ? billingAddress.mobile : undefined) : (
                        popupContent === "Shipping" &&
                        (shipingAddress?.mobile ? shipingAddress.mobile : undefined)))
                form.setFieldsValue({
                    name: undefined,
                    email: popupContent === "Billing" ?
                        (billingAddress?.email ? billingAddress.email : undefined) : (
                            popupContent === "Shipping" &&
                            (shipingAddress?.email ? shipingAddress.email : undefined)),
                    mobile: popupContent === "Billing" ?
                        (billingAddress?.mobile ? billingAddress.mobile : undefined) : (
                            popupContent === "Shipping" &&
                            (shipingAddress?.mobile ? shipingAddress.mobile : undefined)),
                    country: undefined,
                    state: undefined,
                    city: undefined,
                    street: undefined,
                    zipCode: undefined,
                })
                setUiReady(true)
            }
            else if (popupType === "Update" && popupContent === "Billing") {
                const countryName = billingAddress.country;
                setCountry(countryName)
                if (countryName) {
                    const countryInfo = allCountry.find(countrys => countrys.country === countryName);
                    if (countryInfo) {
                        const iso = countryInfo.countryId
                        getState(billingAddress, iso)
                    } else {
                        setUiReady(true)
                    }
                } else {
                    setUiReady(true)
                }
                setStreet(billingAddress.street)
                setZipcode(billingAddress.zipcode)
                setName(billingAddress.name)
                setEmail(billingAddress.email)
                setMobile(billingAddress.mobile)
                form.setFieldsValue({
                    name: billingAddress.name,
                    email: billingAddress.email,
                    mobile: billingAddress.mobile,
                    country: countryName,
                    street: billingAddress.street,
                    zipCode: billingAddress.zipcode,
                })
            }
            else if (popupType === "Update" && popupContent === "Shipping") {
                const countryName = shipingAddress.country;
                setCountry(countryName)
                if (countryName) {
                    const countryInfo = allCountry.find(countrys => countrys.country === countryName);
                    if (countryInfo) {
                        const iso = countryInfo.countryId
                        getState(shipingAddress, iso)
                    } else {
                        setUiReady(true)
                    }
                } else {
                    setUiReady(true)
                }
                setStreet(shipingAddress.street)
                setZipcode(shipingAddress.zipcode)
                setName(shipingAddress.name)
                setEmail(shipingAddress.email)
                setMobile(shipingAddress.mobile)
                form.setFieldsValue({
                    name: shipingAddress.name,
                    email: shipingAddress.email,
                    mobile: shipingAddress.mobile,
                    country: countryName,
                    street: shipingAddress.street,
                    zipCode: shipingAddress.zipcode,
                })
            }
        }
    }, [popupType, confirmPopup, allCountry])
    const handleAccountName = async (type, value) => {
        if (type === "Billing") {
            if (value) {
                const countryName = billingAddress?.country
                setCountry(countryName)
                if (countryName) {
                    const countryInfo = allCountry.find(countrys => countrys.country === countryName);
                    if (countryInfo) {
                        const iso = countryInfo.countryId
                        getState(billingAddress, iso)
                    }
                }
                setStreet(billingAddress?.street)
                setZipcode(billingAddress?.zipcode)
                setName(billingAddress?.name)
                setEmail(billingAddress?.email)
                setMobile(billingAddress?.mobile)
                form.setFieldsValue({
                    name: billingAddress?.name,
                    email: billingAddress?.email,
                    mobile: billingAddress?.mobile,
                    country: countryName,
                    street: billingAddress?.street,
                    zipCode: billingAddress?.zipcode,
                })
            } else {
                form.setFieldsValue({
                    name: undefined,
                    email: undefined,
                    mobile: undefined,
                    country: undefined,
                    state: undefined,
                    city: undefined,
                    street: undefined,
                    zipCode: undefined,
                })
                setCountry(); setState(); setCity(); setZipcode(); setStreet(); setName(); setEmail(); setMobile();
            }
        }
        if (type === "Account") {
            if (value && accountId) {
                try {
                    const response = await FetchAccountDetails(accountId);
                    const countryName = response?.data?.country
                    setCountry(countryName)
                    if (countryName) {
                        const countryInfo = allCountry.find(countrys => countrys.country === countryName);
                        if (countryInfo) {
                            const iso = countryInfo.countryId
                            getState({ state: response?.data?.state, city: response?.data?.city }, iso)
                        }
                    }
                    setStreet(response?.data?.street)
                    setZipcode(response?.data?.postcode)
                    setName(response?.data?.account_name)
                    setEmail(billingAddress?.email ? billingAddress.email : undefined)
                    setMobile(billingAddress?.mobile ? billingAddress.mobile : undefined)
                    form.setFieldsValue({
                        name: response?.data?.account_name,
                        email: billingAddress?.email ? billingAddress.email : undefined,
                        mobile: billingAddress?.mobile ? billingAddress.mobile : undefined,
                        country: countryName,
                        street: response?.data?.street,
                        zipCode: response?.data?.postcode,
                    })
                } catch (error) {
                    message.error(error)
                }
            }
            else {
                form.setFieldsValue({
                    name: undefined,
                    country: undefined,
                    state: undefined,
                    city: undefined,
                    street: undefined,
                    zipCode: undefined,
                })
                setCountry(); setState(); setCity(); setZipcode(); setStreet(); setName();
            }
        }
    }
    return (
        <>
            <Modal
                title={
                    <div style={{ display: "flex", alignItems: "center", gap: "50px" }}>
                        {popupContent} Address
                        <div>
                            <Checkbox disabled={popupContent === "Billing" ? !accountId : false}
                                onChange={(e) => handleAccountName(popupContent === "Billing" ? "Account" : "Billing", e.target.checked)} >
                                {popupContent === "Billing" ? "Copy from Account" : "Same as Billing Address"} </Checkbox>
                        </div>
                    </div >}
                open={confirmPopup}
                onCancel={handleClose}
                maskClosable={false}
                width={700}
                footer={
                    uiReady ? [
                        <div>
                            <Button className="gray-button" onClick={handleClose} size="small">
                                <FeatherIcon icon="x" />Cancel
                            </Button>
                            <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()}>
                                <FeatherIcon icon="save" /> Save
                            </Button>
                        </div>] : false}
            >
                {uiReady ? <AddUser>
                    <div className="user-info-form">
                        <BasicFormWrapper>
                            <Form style={{ width: '100%' }} form={form} name="Address" colon={false} onFinish={(values) => onSubmit(values)}>
                                <Row gutter={30} style={{ padding: "0px 20px" }}>
                                    <Col span={12} style={{ marginBottom: 20 }}>
                                        <Form.Item label="Name" name="name" id="name"
                                            rules={[{ required: true, message: 'Please enter name', }, {
                                                validator: (_, value) => {
                                                    const error = nameOnChangeValidator(value, 50);
                                                    if (error) {
                                                        return Promise.reject(new Error(error));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            }]}>
                                            <Input placeholder="Enter Name" value={name} onChange={(e) => setName(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12} style={{ marginBottom: 20 }}>
                                        <Form.Item label="Email" name="email" id="email"
                                            rules={[{ required: true, message: 'Please enter email', }, {
                                                validator: (_, value) => {
                                                    const error = validateEmailField(value, 50);
                                                    if (error) {
                                                        return Promise.reject(new Error(error));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            }]}>
                                            <Input placeholder="Enter Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12} style={{ marginBottom: 20 }}>
                                        <Form.Item label="Mobile" name="mobile" id="mobile"
                                            rules={[{ required: true, message: 'Please enter mobile', }, {
                                                validator: (_, value) => {
                                                    const error = mobileOnChangeValidator(value, 20);
                                                    if (error) {
                                                        return Promise.reject(new Error(error));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            },]}>
                                            <Input placeholder="Enter Mobile No" pattern="^[0-9+-]+$" value={mobile} onChange={(e) => setMobile(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12} style={{ marginBottom: 20 }}>
                                        <Form.Item label="Country" name="country" id="country"
                                            rules={[{ required: true, message: 'Please select country', }]}
                                             >
                                            <Select
                                                style={{ width: '100%' }}
                                                showSearch allowClear
                                                placeholder="Select Country"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                onChange={handleCountryChange}
                                                value={country}
                                            >
                                                {allCountry?.map((option) => (
                                                    <Option key={option.countryId} value={option.country}>
                                                        {option.country}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12} style={{ marginBottom: 20 }}>
                                        <Form.Item label="State" name="state" id="state"
                                            // rules={[{ required: true, message: 'Please select state', }]} 
                                            >
                                            <Select
                                                style={{ width: '100%' }}
                                                showSearch allowClear
                                                placeholder="Select State"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                onChange={handleStateChange}
                                                value={state}
                                            >
                                                {allState?.map((option) => (
                                                    <Option key={option.stateId} value={option.state}>
                                                        {option.state}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12} style={{ marginBottom: 20 }}>
                                        <Form.Item label="City" name="city" id="city"
                                            // rules={[{ message: 'Please select city', }]}
                                        >
                                            <Select
                                                style={{ width: '100%' }}
                                                showSearch allowClear
                                                placeholder="Select City"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                onChange={handleCityChange}
                                                value={city}
                                            >
                                                {allCity?.map((option) => (
                                                    <Option key={option.cityId} value={option.city}>
                                                        {option.city}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12} style={{ marginBottom: 20 }}>
                                        <Form.Item label="Street name and No" name="street" id="street"
                                            rules={[{ required: true, message: 'Please enter street name and no', }, {
                                                validator: (_, value) => {
                                                    const error = validateAddressLine(value, 100);
                                                    if (error) {
                                                        return Promise.reject(new Error(error));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            }]}>
                                            <Input placeholder="Enter Street name and no" value={street} onChange={(e) => setStreet(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12} style={{ marginBottom: 20 }}>
                                        <Form.Item label="Zip Code" name="zipCode" id="zipCode" rules={[{
                                            validator: (_, value) => {
                                                const error = validateZipCode(value, 25);
                                                if (error) {
                                                    return Promise.reject(new Error(error));
                                                }
                                                return Promise.resolve();
                                            },
                                        }]}
                                        >
                                            <Input placeholder="Enter Zip Code" value={zipcode} onChange={(e) => setZipcode(e.target.value)} />
                                        </Form.Item>
                                    </Col>
                                </Row >
                            </Form>
                        </BasicFormWrapper>
                    </div>
                </AddUser> :
                    <div >
                        <div className="spin" style={{ height: "30rem" }}>
                            <Spin />
                        </div>
                    </div>}
            </Modal >
        </>
    );
};

Popup.propTypes = {
    confirmPopup: PropTypes.bool.isRequired,
    setConfirmPopup: PropTypes.func.isRequired,
    popupType: PropTypes.string.isRequired,
    popupContent: PropTypes.string.isRequired,
    billingAddress: PropTypes.object.isRequired,
    setBillingAddress: PropTypes.func.isRequired,
    shipingAddress: PropTypes.object.isRequired,
    setShipingAddress: PropTypes.func.isRequired,
    accountId: PropTypes.number.isRequired,
};

export default Popup;